import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_contact_key_ext_RowClass} from '../../../dbschema/bl_crm_contact_key_ext.model';
import {bl_crm_contact_key_hdr_RowClass} from '../../../dbschema/bl_crm_contact_key_hdr.model';
import {bl_crm_contact_key_line_RowClass} from '../../../dbschema/bl_crm_contact_key_line.model';
import { bl_crm_contact_key_target_link_RowClass } from '../../../dbschema/bl_crm_contact_key_target_links.model';

export class ContactKeyContainerModel extends BaseContainerModel {
  bl_crm_contact_key_hdr: bl_crm_contact_key_hdr_RowClass = new bl_crm_contact_key_hdr_RowClass();
  bl_crm_contact_key_exts: bl_crm_contact_key_ext_RowClass[] = [];
  bl_crm_contact_key_lines: bl_crm_contact_key_line_RowClass[] = [];
  bl_crm_contact_key_target_links: bl_crm_contact_key_target_link_RowClass[] = [];
}
